module.exports = __webpack_public_path__ + "img/icon-button-ic-pdf.be9451f5.svg";